import React from 'react';
import './NumberInCircle.sass'

function NumberInCircle({children, bgColor}) {
    return (
        <div className={'number_in_circle'} style={{backgroundColor: bgColor}}>
            {children}
        </div>
    );
}

export default NumberInCircle;